import React from "react"
import Seo from "../components/seo"
import NavigationBar from "../components/NavigationBar"
import Footer from "../components/Footer"
import CookiesModal from "../components/CookiesModal"
import SupportForm from "../components/forms/SupportForm"
import { StaticImage } from "gatsby-plugin-image"

import "./support.scss"

import iconArrows from "../images/support-images/arrows.png"
import iconBusiness from "../images/support-images/business.png"
import iconEnvelope from "../images/support-images/envelope.png"
import iconPuzzle from "../images/support-images/puzzle.png"
import iconSeo from "../images/support-images/seo.png"
import iconVerified from "../images/support-images/verified.png"

const SupportSteps = [
  { img: iconEnvelope, text: 'Levantar Ticket en: https://www.derevo.com.mx/support' },
  { img: iconSeo, text: 'Análisis del problema' },
  { img: iconBusiness, text: 'Asignar ticket' },
  { img: iconPuzzle, text: 'Desarrollo de la solución' },
  { img: iconArrows, text: 'Confirmación de la solución aplicada' },
  { img: iconVerified, text: 'Ticket Cerrado' },
]

const SupportPage = () => (
  <>
    <NavigationBar />
    <section id="support">
      <div className="navigationbar-space">
        <div className="hero">
          <div className="img">
            <StaticImage src="../images/support_img.png" alt="support team"/>
          </div>
          <div className="text">
            <h1>Damos <span className="bold">soporte</span> a tu negocio</h1>
            <p>Contáctanos a través de un ticket para nuestro equipo de soporte. Estaremos felices de ayudarte.</p>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="principal-content">
          <div className="support-form">
            <div className="info">
              <div className="description">
                <div className="title">
                  <h2>Así será el proceso de tu ticket</h2>
                </div>
                <div>
                  <ul className="steps-list">
                    {
                      SupportSteps.map((i, index) => (
                        <li key={index}>
                          <div className="icon">
                            <img src={i.img} alt="icon" />
                          </div>
                          <div className="text">
                            <span>0{index + 1}</span>
                            <span>{i.text}</span>
                          </div>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              </div>
              <div className="form">
                <div className="card">
                  <p>Muchas gracias por ponerte en contacto con nosotros, en breve notificaremos al área de soporte tu ticket y recibirás respuesta en un máximo de 48 horas para darle seguimiento a tu caso. Por favor, ayúdanos con los siguientes datos para ponernos en contacto</p>
                  <SupportForm/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
    <CookiesModal />
  </>
)

export default SupportPage

export const Head = ({ location }) => {
  const title = "Soporte"
  const description = "Soporte está aquí para ayudarte."
  const { pathname } = location
  
  return <Seo title={title} description={description} pathname={pathname}/>
}